import { push } from "connected-react-router";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { applicationTypeFromLicenceSubType } from "../../../redux/slice/applicationsUtils";
import { Paragraph, Button, ErrorWithString } from "../../../components/RegularComponents";
import TopNavigationBar from "../../TopNavigationBar";
import { APPLICATION_MODE_NEW, ROUTE_PATH } from "../../../app/constants";
import { useRouteMatch } from "react-router-dom";
import { agencyApplicationSelector } from "../../../redux/selector/agencyApplicationSelector";

export const ResponsibilityConfirmationView = (props) => {
  const dispatch = useDispatch();
  let { path } = useRouteMatch();
  const application = path.split('/')[1];
  const isPrincipalBroker =  (ROUTE_PATH.PB_APP.search(application) !== -1);
  const {agencyApplication} = useSelector(agencyApplicationSelector) || {};
  const licencingSubType = agencyApplication?.licencingSubType;
  
  const [showRoleConfirmationError, setShowRoleConfirmationError] = useState(false);

  let title = `Principal Broker`;
  let p1Text = `The principal broker is responsible for managing the brokerage, brokers and associate brokers.` ;
  let p2Text = `Are you the principal broker for your brokerage?`;
  let errStr = `The Principal Broker must be responsible for managing brokerage, brokers and associate brokers.`;

  if(!isPrincipalBroker) {
    title = `Compliance Officer`;
    p1Text = `The compliance officer needs to handle all licensing responsibilities on behalf of the company.`;
    p2Text = `Are you the compliance officer for your company?`;
    errStr = `The Compliance Officer must be responsible for managing all licensing responsibilities on behalf of the company.`
  }

  const handleNext = (confirmDuty) => () => {
    setShowRoleConfirmationError(!confirmDuty);

    if(confirmDuty) {
      if(isPrincipalBroker) {
        dispatch(push(`/${application}${ROUTE_PATH.MRA_ADD_MAIN_AGENT_WORK_EXPERIENCE_CONFIRMATION}`));
      }
      else {
        // choose compliance officer
        dispatch(push(`/${application}${ROUTE_PATH.MRA_ADD_MAIN_AGENT_SELECT_OFFICER}`));
      }
      
      return;
    }
  };

  return (
    <div className="container">
      <TopNavigationBar 
          {...props}
          hideSaveAndExit 
          applicationType={applicationTypeFromLicenceSubType(licencingSubType)} 
          applicationMode={APPLICATION_MODE_NEW} 
      />
      {/* Title */}
      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <h1>{title}</h1>
        </div>
      </div>

      <div className="row topMarginLarge bottomMarginLarger">
        <div className="col-xs-12 col-lg-8">
          <Paragraph 
            text={[p1Text,p2Text]}
          />
        </div>
      </div>

      {/* Yes/No Answer */}
      <div className="row">
        <div className="col-lg-2 ">
          <Button
            className={"ns-btn-yes-no btn-default"}
            buttonType="primary_regular"
            onClick={handleNext(true)}
            text={"Yes"}
          />
        </div>

        <div className="col-lg-3 has-error">
          <Button
            className={"ns-btn-yes-no btn-default"}
            buttonType="primary_regular"
            onClick={handleNext(false)}
            value={false}
            text={"No"}
          />
          {showRoleConfirmationError &&
            ErrorWithString(errStr)
          }
        </div>
      </div>
    </div>
  );
};
